/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const AbiR = t.interface({});

// optional attributes
const AbiO = t.partial({
  abi: t.string,

  logoUrl: t.string,

  name: t.string
});

export const Abi = t.intersection([AbiR, AbiO], "Abi");

export type Abi = t.TypeOf<typeof Abi>;
